<template>
  <b-container class="d-flex flex-column h-100" fluid>
    <div
      class="pagetitle-container d-flex justify-content-start align-items-center"
    >
      <div class="page-title">
        <h2>Infoservis</h2>
      </div>
      <div class="d-flex flex-grow-1">
        <input-filter
          ref="filter"
          :filters="table.filter"
          :options="filterOptions"
          @onReset="resetFilter"
          @onSearch="search"
        />
      </div>
    </div>
    <div ref="scroll" v-bar class="bar-out">
      <div>
        <file-manager ref="filemanager" :table="table" :url="routes" />
      </div>
    </div>
  </b-container>
</template>
<script>
import InputFilter from '@/components/InputFilter'
import FileManager from '@/components/filemanager/List'

export default {
  components: { InputFilter, FileManager },
  data() {
    return {
      table: {
        loading: false,
        columns: [
          {
            key: 'actions',
            label: '',
            thClass: 'th-shrink',
          },
          {
            key: 'name',
            label: 'Názov',
            tdClass: 'td-link',
            sortable: true,
            sortableKey: 'info_services.name',
            searchable: true,
          },
          {
            key: 'updated_at',
            label: 'Upravené',
            formatter: (value) =>
              value ? this.$options.filters.formatDateTime(value) : '-',
            sortable: true,
            class: 'text-right',
          },
          {
            key: 'size',
            label: 'Veľkosť',
            formatter: (value) =>
              value ? this.$options.filters.fileSize(value) : '-',
            sortable: true,
            class: 'text-right',
          },
          {
            key: 'created_by',
            label: 'Vytvoril',
            formatter: (value, key, item) =>
              item.lastname
                ? this.$root.user.isAdmin
                  ? item.firstname + ' ' + item.lastname
                  : 'ESM'
                : '-',
            sortable: true,
          },
        ],
        sortBy: 'name',
        searchable: false,
      },
      filterOptions: {
        placeholder: 'Filtrovanie a hľadanie...',
      },
      routes: {
        explorer: 'infoservice/get_document_tree',
        show: 'infoservice/documents',
        open: '/api/infoservice/open_file/',
        download: '/api/infoservice/download_file/',
        rename: 'infoservice/doc/rename',
        move: 'infoservice/doc/move',
        upload: 'infoservice/uploadFiles',
        delete: 'infoservice/doc/delete',
        createFolder: 'infoservice/create_folder',
      },
    }
  },
  methods: {
    search() {
      this.$refs.filemanager.$refs.table.searchVal = this.$refs.filter.value
      this.$nextTick(() => {
        this.$refs.filemanager.$refs.table.search()
      })
    },
    resetFilter() {
      this.$refs.filemanager.$refs.table.reset()
    },
  },
}
</script>
